<div edsGrid>
  <div [edsSpacing]="marginBottom === 'auto' ? 'xl' : marginBottom">
    <div class="container">
      <div edsRow>
        <div edsCol>
          <eds-video edsSpacing="lg" [embedScript]="videoEmbed"> </eds-video>
        </div>
      </div>
    </div>
  </div>
</div>
